import Vue from 'vue'
import at from '@/helpers/config/at'
import de from '@/helpers/config/de'

const project = process.env.VUE_APP_PROJECT
const mode = process.env.VUE_APP_MODE
const config = project === 'hilfy' ? at[mode] : de[mode]

const key = '$apiConfig'
Object.defineProperty(Vue.prototype, key, {
    get() {
        return Object.freeze(config)
    },
})

export default config
